import { render, staticRenderFns } from "./VSCode.vue?vue&type=template&id=0d775a2a&"
import script from "./VSCode.vue?vue&type=script&lang=js&"
export * from "./VSCode.vue?vue&type=script&lang=js&"
import style0 from "./VSCode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports